import http from '@/http/aisea/axios'
import moment from 'moment-timezone';
import qs from "qs";
const resource = "/enterprises/crews";

export default {

  search(payload) {
    payload.now = moment().local().format('YYYY-MM-DD');
    return http.get(`${resource}`, {
      params: payload
    });
  },

  fetch(id, payload) {
    return http.get(`${resource}/${id}`, {
      params: payload,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
    });
  },

  add(payload) {
    return http.post(`${resource}`, payload);
  },

  update(id, payload) {
    return http.put(`${resource}/${id}`, payload);
  },

  delete(id) {
    return http.delete(`${resource}/${id}`);
  },
};
